import ComponentLoader from "./components/ComponentLoader";
import "./components/Cookie";

window.autoHandle = window.autoHandle || [];

function initAutoHandleComponents() {
    window.autoHandle.forEach(component => {
        const elements = document.querySelectorAll(component.element);
        elements.forEach(element => {
            if (!element.dataset.autoHandleInitialized) {
                new component.initComponent(element);
                element.dataset.autoHandleInitialized = 'true';
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const hamburger = document.querySelector('.hamburger');
    const menu = document.querySelector('#navigationHeader');

    window.addEventListener('resize', () => {
        if (window.innerWidth < 830) {
            menu.classList.remove('active');
            menu.style.height = '0px';
        } else {
            menu.classList.remove('active');
            menu.style.height = 'auto';
        }
    });

    const matchMedia = window.matchMedia('(max-width: 830px)');

    let height = 0

    if (hamburger && menu && matchMedia.matches) {
        hamburger.addEventListener('click', () => {
            hamburger.classList.toggle('is-active');
            menu.classList.toggle('active');
            if (height === 0) {
                height = menu.querySelector('.menu-inner').clientHeight;
            }
            menu.style.height = menu.classList.contains('active') ? height + 'px' : '0px';
        });
    }

	new ComponentLoader();
	
	initAutoHandleComponents();
});

/**
 * Homepage JavaScript
 */
document.addEventListener('DOMContentLoaded', function() {
    // Initialize Swiper for intro section
    if (document.querySelector('.intro-section .swiper-container')) {
        new Swiper('.intro-section .swiper-container', {
            modules: [Pagination],
            slidesPerView: 1,
            spaceBetween: 30,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
            },
        });
    }

    // Initialize Swiper for slider section
    if (document.querySelector('.sliderSection.swiper-container')) {
        new Swiper('.sliderSection.swiper-container', {
            modules: [Navigation, Autoplay],
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                addIcons: false,
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
        });
    }
});
